import { TURNSTILE_CONFIG } from '@/configs';
import { Turnstile as ReactTurnstile } from '@marsidev/react-turnstile';
import type { TurnstileInstance } from '@marsidev/react-turnstile';
import { forwardRef, useImperativeHandle, useRef } from 'react';

type TurnstileState = 'error' | 'success' | 'expired';

interface ITurnstileProps {
  onStateChange?: (state?: TurnstileState) => void;
  errorMessage?: string;
  onSuccess?: (token: string) => void;
}

export interface ITurnstileElement {
  reset: () => void;
}

export const Turnstile = forwardRef<ITurnstileElement, ITurnstileProps>(
  ({ onStateChange, onSuccess, errorMessage }, ref) => {
    const turnstileRef = useRef<TurnstileInstance | undefined>(undefined);

    useImperativeHandle(
      ref,
      () => ({
        reset: () => turnstileRef.current?.reset(),
      }),
      [],
    );

    return (
      <div>
        <ReactTurnstile
          ref={turnstileRef}
          siteKey={TURNSTILE_CONFIG.TURNSTILE_SITE_KEY}
          onError={() => {
            if (onStateChange) {
              onStateChange('error');
            }
          }}
          onExpire={() => {
            if (onStateChange) {
              onStateChange('expired');
            }
          }}
          onSuccess={(token) => {
            if (onStateChange) {
              onStateChange('success');
            }
            if (onSuccess) {
              onSuccess(token);
            }
          }}
        />
        {errorMessage && <p className='text-error text-metatitle mt-2 error-msg'>{errorMessage}</p>}
      </div>
    );
  },
);
